<template>
	<div class="wrap">
		<common-modal :showClose="false" v-if="isShowModal">
			<div class="modal">
				<div class="body">是否删除该银行卡？</div>
				<div class="footer">
					<div class="cancelBtn" @click="cancleDeleteClick">否</div>
					<div class="confirmBtn" @click="confirmDeleteClick">是</div>
				</div>
			</div>
		</common-modal>
		
		<div v-if="list && list.length">
			<div class="list" v-for="(item,index) in list" :key="index">
				<div class="item"  @click="onSelectCardClick(item)">
					<div class="left">
						<img src="@/assets/images/personal/pic_order_cart.png" class="union-card">
						<div>
							<div class="bank-name">{{item.bank_name}}</div>
							<div class="card-no">尾号{{item.bank_code}}储蓄卡</div>
						</div>
					</div>
					<img src="@/assets/images/my-wallet/ic_recharge_delete.png" class="delete-icon"  @click.stop="onDeleteClick(item)">
				</div>
			</div>
		</div>
		
		<div v-else class="no-order">
			<img src="../../assets/images/no-bank.png">
            <p>暂无添加银行卡</p>
		</div>

		<div class="addCardBtn" @click="toAddNewCard">添加银行卡</div>
	</div>
</template>

<script>
import CommonHeader from '@/components/CommonHeader'
import CommonModal from '@/components/CommonModal'
import { getCardList, deleteCard } from '@/api/wallet'
// 在单独构建的版本中辅助函数为 Vuex.mapMutations
import { mapMutations, mapState } from 'vuex'

export default {
	name: 'bankcardmanage',
	data() {
		return {
			title: '',
			type: '', //分选择银行卡 select 和管理银行卡 manage
			isManage: false,
			list: [],
			isShowModal: false,
			deleteCardInfo: {}
		}
	},
	
	components: {
		CommonHeader,
		CommonModal
	},
	
	beforeCreate(){
		sessionStorage.removeItem("roleType");
	},
	
	beforeRouteLeave(to, from, next) {
	    // 设置下一个路由的 meta
		if(to.name=="index-sale"){
			to.meta.keepAlive = true; // 让 A 缓存，即不刷新
		}
		next();
	},
	
	computed: {
		...mapState(['selected_card'])
	},
	
	mounted() {
		//根据路由参数来判断时银行卡管理还是选择银行卡
		let type = this.$route.query.type;
		this.type = type;
		if (type=== 'manage') {
			document.title = '银行卡管理';
			this.isManage = true;
		} else {
			document.title = '选择银行卡'
		}
		this.getCards();
	},
	
	methods: {
		...mapMutations(['update_selected_card']),
		async getCards() {
			const { data, status } = await getCardList();
			if (status !== 200 ) return
            this.list = data.data;
			if(this.list && this.list.length){
				this.list.forEach( item => {
					item.bank_code = item.bank_code.substr(-4);//获取银行卡后4位
				})
				// this.update_selected_card(data.data[0])
			}	
		},
	
		// 删除卡
		onDeleteClick (item) {
			this.deleteCardInfo = item;
			this.isShowModal = true;
		},
		
		// 加卡
		toAddNewCard() {
			this.$router.push('/add-card')
		},
		
		// 取消删除卡
		cancleDeleteClick() {
		  this.isShowModal = false;
		},
		
		async confirmDeleteClick() {
			const { data, status } = await deleteCard(this.deleteCardInfo.uuid);
			if(status !== 200) return
			this.isShowModal = false;
			window.toast('删除成功', 'txt')
			this.getCards()
		},
		
		onSelectCardClick(item) {
			if (this.type === 'manage') return
			this.update_selected_card(item);
            this.$router.push('/withdraw-balance')
		}
	}
}
</script>

<style lang="less" scoped>
@import '~@/assets/styles/variable.less';
@import '~@/assets/styles/handleMethods.less';
.no-order{margin: 0 auto;margin-top:50%;margin-bottom: 50%}
.no-order img{width: 100px;height:54px;display: block;margin: 0 auto}
.no-order p{margin-right: 10px;;text-align: center;font-size:13px;font-family:PingFangSC-Medium;font-weight:500;color:rgba(207,207,207,1);line-height:18.5px;margin-top: 10.5px}
.wrap {
  // background:rgba(245,245,245,1);
  .modal {
    .w(280);
    .h(145.5);
    .f-s(18);
    background:rgba(255,255,255,1);
    border-radius:4px;
    font-family:PingFangSC-Regular;
    font-weight:400;
    color:rgba(0,0,0,1);
    .body {
      .p-t(38);
      .m-b(32);
      text-align: center;
    }
    .footer {
      display: flex;
      justify-content: center;
      align-items: center;
      text-align: center;
      .cancelBtn, .confirmBtn {
         .w(140);
         .h(50);
         .l-h(50);
      }
      .cancelBtn {
        border-top: 1px solid #eee;
        border-right: 1px solid #eee;
      }
      .confirmBtn {
        border-top: 1px solid #eee;
      }
    }
  }
	.list {
		background: #fff;
		.item {
			.h(71);
			.p-l(26);
		  .p-r(33);
			display: flex;
			align-items: center;
			justify-content: space-between;
			border-bottom: 1px solid #eee;
			.left {
				display: flex;
				align-items: center;
			}
			.union-card {
				.w(33.5);
				.h(21);
				.m-r(12.5);
			}
			.bank-name {
				.f-s(14);
				font-family:PingFangSC-Medium;
				font-weight:500;
				color:rgba(20,20,20,1);
				.m-b(3);	
			}
			.card-no {
				.f-s(12);
				font-family:PingFangSC-Regular;
				font-weight:400;
				color:rgba(102,102,102,1);
				
			}
			.delete-icon {
				.w(16.5);
				.h(18);

			}
		}
	}
  .no-bankcard {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    .m-t(200);
    .no-address-icon {
      .w(60);
      .h(60);
      .m-b(25);
    }
    .no-address-text {
      .h(20);
      .l-h(20);
      .f-s(14);
      font-family:PingFangSC-Medium;
      font-weight:500;
      color:rgba(155,155,155,1);
    }
}
	.addCardBtn {
		.h(46);
		.l-h(46);
		.f-s(16);
		width: 100%;
		position: fixed;
		bottom: 0;
		text-align: center;
		font-family:PingFangSC-Regular;
		font-weight:400;
		color:rgba(255,255,255,1);
		background:rgba(74,144,226,1)
	}
}
</style>